import {useCallback, useEffect, useMemo, useState} from "react";
import {useDispatch} from "react-redux";
import cap17drive from "../index";
import auth from "../../../utils/authentication";
import {fetchSeasonDetails} from "../api/cap17drive-api";
import useViewTMDBContent from "./useViewTMDBContent";

export const useSeasonEpisodesData = (serie: any, seasonNumber: number | string | null) => {
    const dispatch = useDispatch();
    const [seasons, setSeasons] = useState<Record<string | number, any>>({});
    const [seasonSelected, setSeasonSelected] = useState<number | string | null>(null);
    const {markEpisodeAsView} = useViewTMDBContent();

    const season = useMemo(() => {
        if (seasonSelected == null) return null;
        return seasons[seasonSelected] ?? null;
    }, [seasonSelected, seasons]);

    useEffect(() => {
        if (!serie?.id || seasonNumber == null || !auth.currentUser) return;
        dispatch(cap17drive.actions.clearSelectedSeason() as any);
        dispatch(cap17drive.actions.fetchSeason(serie.id, seasonNumber, auth.currentUser.uid) as any);

        fetchSeasonDetails(serie.id, seasonNumber, auth.currentUser.uid).then(data => {
            setSeasons(prev => ({
                ...prev,
                [seasonNumber]: data
            }));
        }).catch(() => {});

        setSeasonSelected(seasonNumber);
    }, [serie?.id, seasonNumber, dispatch]);

    const updateItemInSeason = useCallback((updatedEpisode: any) => {
        if (!season) return;
        setSeasons(prev => {
            const updatedSeason = {...prev[season.season_number]};
            updatedSeason.episodes = (updatedSeason.episodes || []).map((ep: any) => {
                if (ep.episode_number === updatedEpisode.episode_number) {
                    return {...updatedEpisode};
                }
                return ep;
            });
            return {
                ...prev,
                [season.season_number]: updatedSeason,
            };
        });
    }, [season]);

    return {
        season,
        episodes: season?.episodes || [],
        loading: !season?.episodes?.length,
        updateItemInSeason,
        markEpisodeAsView,
    };
};

export default useSeasonEpisodesData;
